import React, { useEffect, useState } from 'react'
import { getDate } from '../utils';
import { loadMessage, loadMessageReplies, saveReply } from '../utils/Network';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import parse from "html-react-parser";

function MessageContent({id}) {

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const [message, setMessage] = useState(null);
    const [reply, setReply] = useState("");
    const [replies, setReplies] = useState(null);
    
    useEffect(() => {
        if (id) {
            loadMessage(id).then(message=>{
                setMessage(message);
            })

            loadMessageReplies(id).then(data=>{
                setReplies(data.results);
            })
        }
    }, []);

    const handleReplyChange = (data) => {
        setReply(data)
 
     }

     const SaveChanges = ()=>{
        setError("")

        if(reply==""){
            setError('Please Enter Reply')
            return
        }
        
        setLoading(true)
        saveReply(id,reply).then((res)=>{
            //console.log(res)
            //setReplies([res , ...replies])
            
            setLoading(false)
            loadMessageReplies(id).then(data=>{
                setReplies(data.results);
            })
        })
     }

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <h3 className="box-title mb-10"></h3>
                <ol className="breadcrumb">
                    <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                    <li className="active">Message</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">

                    <div className="col-md-12">
                        <div className="box ">
                            <div className="box-header">
                                Reply
                            </div>
                            <div className="box-body padding-10 bg-ddd kfont text-light">
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={reply}
                                    onReady={editor => {
                                        // You can store the "editor" and use when it is needed.
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        handleReplyChange(data)
                                    }}
                                />
                                <hr />
                                <button className="btn btn-primary pull-right" onClick={SaveChanges}>Save Reply</button>

                                
                            </div>
                            {error &&
                                    <div className="alert alert-danger mt-5">
                                        {error}
                                    </div>
                                }
                                {loading &&
                                    <div className="alert alert-info  mt-5">
                                        Please Wait...
                                    </div>
                                }
                                {done &&
                                    <div className="alert alert-success  mt-5">
                                        {done}
                                    </div>
                                }

                        </div>
                    </div>
                    
                    {replies?.map((reply)=>(
                        <div className="col-md-12" key={reply.id}>
                            <div className="box ">
                                <div className="box-header bg-reply">
                                    <div className="col-md-6">
                                        {getDate(reply.created_at)}
                                    </div>
                                    <div className="col-md-6 message-header-right">
                                        <a href={`usertalent/${reply.user?.profile.id}`}  target="_blank" className="color-white"  >
                                            {reply.user?.profile.first_name + " " + reply.user?.profile.last_name}
                                            <img src={reply.user?.profile.image} />
                                        </a>
                                    </div>
                                </div>
                                <div className="box-body padding-10 kfont text-light">
                                    {parse(reply.message)}
                                </div>


                            </div>
                        </div>
                    ))} 
                    {message && 
                    <div className="col-md-12">
                        <div className="box ">
                            <div className="box-header">
                                <div className="col-md-6">
                                    {getDate(message.created_at)}
                                </div>
                                <div className="col-md-6 message-header-right">
                                    <a href={`usertalent/${message.user?.profile.id}`} target="_blank" className="color-white"  >
                                        {message.user.profile.first_name + " " + message.user.profile.last_name}
                                        <img src={message.user.profile.image} />
                                    </a>
                                </div>
                            </div>
                            <div className="box-body padding-10 kfont text-light">
                                {message.message}
                            </div>


                        </div>
                    </div>
                    }
                </div>
            </section>
        </div>
    )
}

export default MessageContent
